export const INTEGRATION_STATUS_LOCKED = 'locked';
export const INTEGRATION_STATUS_ACTIVE = 'active';
export const INTEGRATION_STATUS_CONNECTED = 'connected';
export const INTEGRATION_STATUS_ATTENTION = 'attention';
export const INTEGRATION_STATUS_INACTIVE = 'inactive';
export const INTEGRATION_STATUS_ERROR = 'error';
